//  Dependencies

import React, { Component} from 'react';

// Style

import './Testimonial.css';

const Testimonial = (props) => {
  return (
    <div className="testimonial">
      <div className="testimonial__image-wrapper">
        <img alt="Testimonial" className="testimonial__image" src={`${props.img}`} />
        <div className="testimonial__caption">{props.name}</div>
      </div>
      <div className="testimonial__text">
        <p><span className="testimonial__quotes">"</span>{props.text}
          <span className="testimonial__quotes">"</span>
        </p>
      </div>
    </div>
  );
}

export default Testimonial;



// WEBPACK FOOTER //
// ./src/Testimonial/Testimonial.js